<div class="flex align-items-center justify-content-center text-sm mt-3">
    <mat-icon aria-hidden="true" aria-label="Code" fontIcon="code"></mat-icon>
    <div class="px-2">{{ footerText }}</div>
</div>
